var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn blue btn_big no-drag pointer",on:{"click":_vm.login}},[_vm._v("\n  "+_vm._s(_vm.$t('account.login'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }